<template>
  <div>
    <loader :loading="loading"/>
    <header class="c-toolbar" v-if="!loading">
      <div class="l-level">
        <div class="l-level__left">
          <img :src="fromModuleDefinition.logo" class="logo" alt="">
          <i class="i-arrow icon-arrow-right"></i>
          <img :src="toModuleDefinition.logo" class="logo" alt="">
          <h1 class="c-toolbar__title title">Criar anúncio</h1>
        </div>
      </div>
    </header>

    <panel title="Configuração para publicação dos anúncios">
      <loader :loading="accountLoading"/>

      <panel :title="configuration.label" :titleChangeble="true" class="blue-panel" :useAcordion="true" :acordionDefault="true" v-for="configuration in announcementConfigurations">
        <div slot="header-right">
          <span class="badge warning" v-if="configuration.isEmpty">Preencher</span>
          <span class="badge warning" v-if="configuration.isAlreadyExists">Repetido</span>
        </div>

        <panel>
          <div class="l-row">
            <form-group :label="$t('mercadoLivre.account.label')" :required="true">
              <select v-model="configuration.account" class="form-select" @change="changeAccount(configuration.account)">
                <option :value=null>Selecione</option>
                <option v-for="account in mercadoLivreAccounts" :value="account">{{ `${account.name} (${account.nickname})` }}</option>
              </select>
            </form-group>

            <form-group :label="$t('mercadoLivre.officialStore.label')" v-if="configuration.account && officialStores[configuration.account.identifier] && officialStores[configuration.account.identifier].length" :required="true">
              <select v-model="configuration.officialStore" class="form-select" @change="changeTitle">
                <option :value=null>Selecione</option>
                <option v-for="officialStore in officialStores[configuration.account.identifier]" :value="officialStore">{{ officialStore.label }}</option>
              </select>
            </form-group>

            <form-group label="Tipo" :required="true">
              <select class="form-select" v-model="configuration.announcementType" @change="changeTitle">
                <option :value=null>{{ $t('choose.label') }}</option>
                <option v-for="type in announcementTypeOptions" :key="type" :value="type">{{ $t(`mercadoLivre.types.${type}.label`) }}</option>
              </select>
            </form-group>
          </div>
        </panel>
      </panel>

      <div class="u-textRight">
        <button class="btn btn--info" @click="addAnnouncementConfiguration">Adicionar nova</button>
      </div>
    </panel>

    <marketplace-announcement-product ref="marketplaceProvideProduct" v-for="product in products" :key="product" :announcementConfigurations="announcementConfigurations" :product="product" :fromModule="fromModule" />

    <panel>
      <button :disabled="saving" v-bind:class="{ 'is-loading': saving }" class="btn btn--success" @click="save">{{ $t('announcement.label') }}</button>
    </panel>
  </div>
</template>

<script>
import api from '@/api'
import { getAllUrlParams } from '@/helper'
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { merge, cloneDeep } from 'lodash'
import Loader from '@/components/template/Loader'
import Panel from '@/components/template/Panel'
import FormGroup from '@/components/template/FormGroup'
import notifier from '@/notifier'
import MarketplaceAnnouncementProduct from '@/components/marketplace/mercadoLivre/announcement/Product'
import Checkbox from '@/components/template/Checkbox'
import RadioButton from '@/components/template/RadioButton'

export default {
  provide: {
    maxDescriptionLengthDI: 50000,
    maxTitleLengthDI: 60
  },
  data: () => ({
    loading: true,
    accountLoading: false,
    saving: false,
    announcementConfigurations: [],
    selectedAccounts: [],
    products: [],
    toModule: null,
    fromModule: null,
    presetCategorization: [],
    presetIndex: 0,
    officialStores: {},
    announcementTypeOptions: [
      'gold_pro',
      'gold_special',
      'free'
    ]
  }),
  props: {
    fromModuleType: {
      type: String,
      required: true
    },
    fromModuleIdentifier: {
      type: String,
      required: true
    }
  },
  async mounted () {
    this.clearErrors()

    this.toModule = {
      type: 'marketplace',
      identifier: 'mercadoLivre'
    }

    this.fromModule = {
      type: this.fromModuleType,
      identifier: this.fromModuleIdentifier
    }

    this.accountLoading = true

    await this.fetchAccounts({
      options: {
        active: true
      }
    })

    if (!this.mercadoLivreAccounts.length) {
      notifier.error('Você precisa pelo menos ter uma conta ativa para criar anúncios!', 'Conta')
      this.$router.push('/marketplace/mercadoLivre/accounts')
    }

    this.addAnnouncementConfiguration()

    this.accountLoading = false

    await this.fetchPresets({})

    if (getAllUrlParams().productId) {
      await this.addItemBySourceAndProductId({ source: {type: this.fromModuleType, identifier: this.fromModuleIdentifier}, productId: getAllUrlParams().productId })
    }

    this.products = this.getItemsSelected()
      .map(product => {
        if (this.toModuleDefinition.module.configs.product.appendReferenceCodeOnTitle) {
          const referenceCodes = product.variations
            .map(variation => variation.manufacturerReference)
            .filter(function (item, pos, self) {
              return self.indexOf(item) === pos
            })

          product.title += ` ${referenceCodes.join(' ')}`
        }

        const description = [
          product.description
        ]

        if (this.toModuleDefinition.module.configs.product.description) {
          const descriptionConfig = this.toModuleDefinition.module.configs.product.description

          if (descriptionConfig.hasOwnProperty('header')) {
            description.unshift(descriptionConfig.header)
          }

          if (descriptionConfig.hasOwnProperty('footer')) {
            description.push(descriptionConfig.footer)
          }
        }

        product.description = description.join('\n').trim()
        product.status = null
        product.errors = []
        product.attributes = []
        product.typeCheckout = false
        product.productCatalogId = null
        product.type = this.toModuleDefinition.module.configs.product.type
        product.shippingMode = this.toModuleDefinition.module.configs.product.shippingMode
        product.shippingFreeRule = {}
        product.variations = product.variations.map(variation => {
          const fields = {
            status: null,
            errors: [],
            selected: (variation.quantity > 0),
            stock: {
              quantity: variation.quantity,
              reducer: this.toModuleDefinition.module.configs.product.stock.reducer
            },
            price: {
              type: this.toModuleDefinition.module.configs.product.price.type,
              cost: 0,
              auxiliary: this.getAuxiliary(),
              previous: variation.previousPrice,
              current: variation.currentPrice
            },
            attributes: [],
            sourceAttributes: variation.attributes
          }
          merge(variation, fields)

          return variation
        })

        return product
      })

    if (!this.products.length) {
      this.redirectToProductProvideList()
    }

    setTimeout(() => (this.loading = false), 1500)
  },
  methods: {
    ...mapActions('itemsSelected', [
      'addItemBySourceAndProductId'
    ]),
    ...mapActions('sendAnnouncements', [
      'add',
      'send'
    ]),
    ...mapActions('mercadoLivreAccounts', [
      'fetchAccounts',
      'setAccounts'
    ]),
    ...mapActions('errors', [
      'clearErrors'
    ]),
    ...mapActions('presets', [
      'fetchPresets'
    ]),
    redirectToProductProvideList () {
      this.$router.push(`/${this.fromModuleType}/${this.fromModuleIdentifier}/products`)
    },
    redirectToProductsSentReport () {
      this.$router.push(`/marketplace/mercadoLivre/announcement/report/${this.fromModuleType}/${this.fromModuleIdentifier}`)
    },
    changeTitle () {
      this.announcementConfigurations.map(configuration => {
        if (!Object.keys(configuration).every(key => configuration[key] !== null || key === 'officialStore')) {
          configuration.label = 'Configure a regra de publicação'
          return configuration
        }

        const title = []

        if (configuration.account) {
          title.push(`${configuration.account.name} (${configuration.account.nickname})`)
        }

        if (configuration.officialStore) {
          title.push(`${configuration.officialStore.code}`)
        }

        if (configuration.announcementType) {
          title.push(this.$t(`mercadoLivre.types.${configuration.announcementType}.label`))
        }

        if (configuration.shippingFree) {
          title.push('Frete grátis')
        } else {
          title.push('Frete pago')
        }

        configuration.label = title.join(' - ')
      })
    },
    addAnnouncementConfiguration () {
      this.changeTitle()

      let type = null
      try {
        type = this.toModuleDefinition.module.configs.product.type
      } catch (e) {
      }

      let account = null
      if (this.mercadoLivreAccounts.length === 1) {
        account = this.mercadoLivreAccounts[0]

        this.changeAccount(account)
      }

      this.announcementConfigurations.push({
        label: 'Configure a regra de publicação',
        account: account,
        officialStore: null,
        announcementType: type,
        shippingFree: false,
        isAlreadyExists: false,
        isEmpty: false
      })

      this.changeTitle()
    },
    changeAccount (account) {
      this.changeTitle()

      if (!account || this.officialStores[account.identifier]) {
        return
      }

      this.accountLoading = true

      api.mercadoLivre.getOfficialStores(account.identifier)
        .then(officialStores => {
          this.officialStores[account.identifier] = officialStores
          this.officialStores[account.identifier].unshift({code: 'none', label: 'Não utilizar'})
        })
        .catch(() => { this.officialStores[account.identifier] = [] })
        .finally(() => { this.accountLoading = false })
    },
    async save () {
      this.saving = true

      this.clearErrors()

      let hasEmpty = false

      this.announcementConfigurations.map(configuration => {
        configuration.isEmpty = false

        if (!configuration.account || !configuration.announcementType) {
          configuration.isEmpty = true
          hasEmpty = true
        }
      })

      if (hasEmpty) {
        this.saving = false
        return notifier.error('Configure as regras de publicação do anúncio!', 'Configurar regras de publicação')
      }

      let hasAlreadyExists = false

      this.announcementConfigurations.map(configuration => {
        configuration.isAlreadyExists = false

        const configurationCompare = cloneDeep(configuration)
        delete configurationCompare.isEmpty
        delete configurationCompare.isAlreadyExists

        if (
          this.announcementConfigurations
            .filter(cfg => {
              const cfgCompare = cloneDeep(cfg)
              delete cfgCompare.isEmpty
              delete cfgCompare.isAlreadyExists
              return JSON.stringify(configurationCompare) === JSON.stringify(cfgCompare)
            }).length > 1
        ) {
          configuration.isAlreadyExists = true
          hasAlreadyExists = true
        }
      })

      if (hasAlreadyExists) {
        this.saving = false
        return notifier.error('Você possui configurações repetidas!', 'Configurações repetidas')
      }

      let products = []
      let hasError = false
      this.$refs.marketplaceProvideProduct.map((component) => {
        try {
          const formattedProducts = component.formatProduct()

          for (let i in formattedProducts) {
            products.push(formattedProducts[i])
          }
        } catch (e) {
          hasError = true
          notifier.error(e.message, 'Erro')
        }
      })

      products.forEach(function (product) {
        product.attributes.forEach(function (attribute) {
          if (attribute.id === 'BRAND' && attribute.value_name === 'custom') {
            hasError = true
            notifier.error('Preencha a marca personalizada do produto', 'Erro')
          }
        })
      })

      if (hasError) {
        this.saving = false
        return
      }

      await this.add(products)

      if (this.allVariations.length === 0) {
        this.saving = false
        return notifier.warning('Nenhuma variação foi selecionada!', 'Selecione as variações')
      }

      const sentSuccess = await this.send({
        type: 'marketplace',
        identifier: 'mercadoLivre'
      })

      this.saving = false

      if (sentSuccess) {
        await this.setAccounts(this.selectedAccounts)

        this.redirectToProductsSentReport()
      }
    },
    getPresetItemByTypeAndFrom (type, from) {
      const preset = this.presets.find(preset => preset.type === type)

      if (preset === undefined) {
        return null
      }

      if (preset.items.length) {
        let item = null
        switch (type) {
          case 'categorization':
            item = preset.items.filter(item => item.from !== undefined && item.from.category === from.category)
            break

          case 'color':
            item = preset.items.filter(item => item.from !== undefined && item.from.color === from.color)
            break
        }

        if (item !== null && item.length === 1) {
          return item[0].to
        }

        return null
      }
    },
    getPresetItemsCategorization (categories) {
      if (!categories) {
        return
      }

      const categoriesForSearchPreset = []
      this.getPresetItemsCategorizationRecursive(categories, categoriesForSearchPreset)

      this.presetCategorization = []

      for (let i in categoriesForSearchPreset) {
        const categories = categoriesForSearchPreset[i]

        const preset = this.getPresetItemByTypeAndFrom('categorization', { category: categories.join(' > ') })

        if (preset !== null) {
          this.presetCategorization.push(preset)
        } else {
          for (let j in categories) {
            const category = categories[j]

            const presetOld = this.getPresetItemByTypeAndFrom('categorization', { category: category })

            if (presetOld !== null) {
              this.presetCategorization.push(presetOld)
            }
          }
        }
      }

      if (this.presetCategorization.length === 1) {
        return cloneDeep(this.presetCategorization[0])
      }

      return null
    },
    getPresetItemsCategorizationRecursive (categories, categoriesForSearchPreset) {
      if (!categories) {
        return
      }

      for (let i in categories.filter(category => category)) {
        const category = categories[i]

        if (!categoriesForSearchPreset[this.presetIndex]) {
          categoriesForSearchPreset[this.presetIndex] = []
        }

        categoriesForSearchPreset[this.presetIndex].push(category.name)

        if (category.children !== null) {
          this.getPresetItemsCategorizationRecursive(category.children, categoriesForSearchPreset)
        } else {
          this.presetIndex++
        }
      }
    },
    getAuxiliary () {
      let auxiliary = 0

      if (this.toModuleDefinition.module.configs.product.price.type === 'percent') {
        auxiliary = this.toModuleDefinition.module.configs.product.price.percent
      }

      if (this.toModuleDefinition.module.configs.product.price.type === 'fixedValue') {
        auxiliary = this.toModuleDefinition.module.configs.product.price.fixedValue
      }

      return auxiliary
    }
  },
  computed: {
    ...mapGetters('itemsSelected', [
      'getItemsSelected'
    ]),
    ...mapGetters('module', [
      'getDefinitionModuleByIdentifierAndType'
    ]),
    ...mapGetters('sendAnnouncements', [
      'getAllVariations'
    ]),
    ...mapGetters('errors', [
      'getError'
    ]),
    ...mapFields({
      mercadoLivreAccounts: 'mercadoLivreAccounts.accounts'
    }),
    ...mapGetters('presets', [
      'getPresetItemsByFromAndTo'
    ]),
    toModuleDefinition () {
      return this.getDefinitionModuleByIdentifierAndType('marketplace', 'mercadoLivre')
    },
    fromModuleDefinition () {
      return this.getDefinitionModuleByIdentifierAndType(this.fromModuleType, this.fromModuleIdentifier)
    },
    allVariations () {
      return this.getAllVariations()
    },
    presets () {
      return this.getPresetItemsByFromAndTo(
        { type: this.fromModuleType, identifier: this.fromModuleIdentifier },
        { type: 'marketplace', identifier: 'mercadoLivre' }
      )
    }
  },
  components: {
    Loader,
    Panel,
    FormGroup,
    MarketplaceAnnouncementProduct,
    Checkbox,
    RadioButton
  }
}
</script>

<style lang="sass" scoped>
  .logo
    max-height: 30px

  .title
    margin-left: 20px

  .i-arrow
    font-size: 20px
    margin: 0 20px

  .editor
    height: 250px
    margin-bottom: 31px

  .checkbox-block
    display: inline-block

  .account-list
    padding: 0 0 0 0

  ul
    list-style-type: none
</style>



// WEBPACK FOOTER //
// Announcement.vue?298f33ae